document.addEventListener("click", (e) => {
  const dropdownMenu = document.querySelector(".search-facets ul.dropdown-menu") as HTMLUListElement;

  if (dropdownMenu) {
    if ((e.target as HTMLElement).closest("#search-dropdown")) {
      e.preventDefault(); 
      dropdownMenu.classList.add("show");
    } else if (!(e.target as HTMLElement).closest(".search-facets ul.dropdown-menu")) {
      dropdownMenu.classList.remove("show");
    }    
  }
  
}); 